import React from "react";
import Header from "../components/Header";
import FooterSection from "../components/FooterSection";
import FaqSection from "../components/FaqSection";
import ContactSection from "../components/ContactSection";
import NoteSection from "../components/NoteSection";
import PagesHero from "../components/PagesHero";

function Faqs() {
  return (
    <div>
      <Header />
      <PagesHero page={"Faqs"} />
      <FaqSection />
      <NoteSection />
      <ContactSection />
      <FooterSection />
    </div>
  );
}

export default Faqs;
